import React from "react";

function UNDecadeLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="239.2"
      height="85"
      viewBox="0 0 835.503 296.747"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            d="M0 0H292.383V296.747H0z"
            data-name="Rectangle 1446"
            transform="translate(97.49 96.501)"
          ></path>
        </clipPath>
      </defs>
      <g data-name="Group 3324" transform="translate(-12661.49 -9150.501)">
        <g data-name="Group 3323">
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3315"
            transform="translate(12564 9054)"
          >
            <path
              fill="#26bde2"
              d="M369.165 173.952a174.767 174.767 0 00-12.59-17.856q-2.738-3.357-5.726-6.531c-2.225-2.312-4.852-5.841-8.457-4.012q-1.877.923-3.747 1.9a172.428 172.428 0 00-43.3 32.122c-9.9 10.271-17.453 25.556-28.148 34.862-14.285 12.7-33.438 12.644-47.661.034-7.56-6.664-13.92-18.057-20.3-25.963-9.9-12.494-24.066-24.923-38.113-33.868a169.194 169.194 0 00-16.094-9.09 4.755 4.755 0 00-5.38.888 116.272 116.272 0 00-8.82 9.656 172.8 172.8 0 00-12.629 17.859 5.082 5.082 0 002.73 7.514c18.866 6.055 33.729 18.705 46.175 34.219a273.956 273.956 0 0017.978 20.989c25.545 27.982 66.044 36.867 99.266 14.6 10.61-7.06 19.424-16.329 27.524-26.046 7.437-9.084 14.569-18.6 23.64-26.115a92.23 92.23 0 0122.924-14.6 80.164 80.164 0 018-3.048 5.058 5.058 0 002.731-7.514"
              data-name="Path 5679"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3316"
            transform="translate(12564 9054)"
          >
            <path
              fill="#dda63a"
              d="M354.578 324.4a33.52 33.52 0 00-6.411-.385c-16.386.371-30.571 12.243-45.427 18.291-18.468 7.777-37.853 11.021-57.993 10.908-20.877.312-41.161-2.8-60.32-10.908-10.141-4.27-19.234-10.4-29.385-14.647-7.922-3.312-16.965-5.082-25.205-2.6-2.052.619-4.362 1.419-5.576 3.262a3.261 3.261 0 00.2 3.906 144 144 0 0074.324 54.053c59.417 20.044 130.986-4.726 164.065-54.273 2.94-4.718-4.863-7.031-8.276-7.61"
              data-name="Path 5680"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3317"
            transform="translate(12564 9054)"
          >
            <path
              fill="#bf8b2e"
              d="M362.854 332.008c2.941-4.718-4.862-7.031-8.276-7.609a33.514 33.514 0 00-6.41-.385c-25.413 4.953-37.27 29.842-56.176 44.552-20.711 15.861-43.561 22.134-69.543 20.34-7.458-.38-16.145-.671-23.66-2.624 59.418 20.043 130.985-4.726 164.065-54.274"
              data-name="Path 5681"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3318"
            transform="translate(12564 9054)"
          >
            <path
              fill="#56c02b"
              d="M388.416 226.656a5.009 5.009 0 00-5.114-4.129 64.043 64.043 0 00-7.6.544c-36.093 4.564-55.543 22.4-71.591 37.085-16.423 15.032-29.4 26.907-60.9 26.907-31.029 0-43.932-11.86-60.266-26.877-16.687-15.341-39.815-34.04-78.884-37.656a4.786 4.786 0 00-5.116 4.13 148.928 148.928 0 00-1.457 20.683c0 4.4.211 8.758.593 13.062a4.8 4.8 0 004.285 4.317c23.948 2.694 38.562 13.528 53.005 26.8 14.776 13.586 32.484 29.854 63.663 35.57.077.014.151.031.229.045a138.462 138.462 0 0042.745.891 108.9 108.9 0 0032.731-9.565 119.427 119.427 0 0023.6-15.249c4.571-3.718 8.932-7.684 13.277-11.662 14.528-13.3 29.217-24.15 53.345-26.839a4.834 4.834 0 004.316-4.348c.379-4.292.591-8.632.591-13.026a149.44 149.44 0 00-1.458-20.688"
              data-name="Path 5682"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3319"
            transform="translate(12564 9054)"
          >
            <path
              fill="#0a97d9"
              d="M284.344 251.273c10.611-7.06 19.426-16.328 27.524-26.045 7.438-9.085 14.571-18.6 23.64-26.116a92.206 92.206 0 0122.924-14.6 79.448 79.448 0 018-3.048 5.061 5.061 0 002.731-7.515 175.01 175.01 0 00-12.591-17.857 117.878 117.878 0 00-5.725-6.53c-2.225-2.312-4.853-5.84-8.458-4.012q-1.877.923-3.746 1.9c-12.256 8.048-29.011 24.4-42.594 57.305-39.455 95.569-110.972 31.913-110.972 31.913 25.545 27.984 66.045 36.868 99.265 14.6"
              data-name="Path 5683"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3320"
            transform="translate(12564 9054)"
          >
            <path
              fill="#e5243b"
              d="M284.646 102.408c-.525-3.093-1.9-5.29-4.573-5.795a4.426 4.426 0 00-.369-.05 9.892 9.892 0 00-2.192 0c-7.207.778-13.708 6.845-18.386 11.962-5.346 5.966-8.83 11.633-13.031 18.734-4.041-11.7-12.965-27.56-27.12-24.5-13.924 2.652-22.33 17.682-18.476 30.943 2.841 10.867 8.278 20.827 14.546 30.074 4.815 7.1 9.585 14.28 15.172 20.812a64.036 64.036 0 004.791 5.173 17.446 17.446 0 008.676 4.887c6.816 1.2 11.456-4.687 14.74-9.8 11.6-18.139 18.816-38.757 23.833-59.594.7-3.107 1.479-6.453 2.034-9.846a42.556 42.556 0 00.355-13"
              data-name="Path 5684"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3321"
            transform="translate(12564 9054)"
          >
            <path
              fill="#c5192d"
              d="M284.646 102.408c-.525-3.093-1.9-5.29-4.573-5.795-.115-.022-.25-.034-.369-.05a3.012 3.012 0 00-.789.046s-12.286 1.932-15.615 23.414c-3.259 21.029-2.844 79.759-26.371 70.914a8.72 8.72 0 01-1.921-1.174 17.446 17.446 0 008.676 4.887c6.816 1.2 11.456-4.687 14.74-9.8 11.6-18.139 18.816-38.757 23.833-59.594.7-3.107 1.479-6.453 2.034-9.846a42.555 42.555 0 00.355-13"
              data-name="Path 5685"
            ></path>
          </g>
          <g
            clipPath="url(#clip-path)"
            data-name="Group 3322"
            transform="translate(12564 9054)"
          >
            <path
              fill="#3f7e45"
              d="M388.416 226.656a5.009 5.009 0 00-5.114-4.129c-.386 0-.742 0-1.086.006-.553.019-1.059.044-1.7.082-66.21 4.373-92.691 138.708-192.229 93.87 13.91 7.414 31.454 12.729 55.205 12.729 46.989 0 69.8-20.879 88.132-37.656 14.528-13.3 29.217-24.15 53.345-26.839a4.834 4.834 0 004.316-4.348c.379-4.292.591-8.632.591-13.026a149.444 149.444 0 00-1.458-20.689"
              data-name="Path 5686"
            ></path>
          </g>
          <path
            fill="#1d1d1b"
            d="M833.4 160.314c5.506 0 9.107-3.388 9.107-8.556v-12.283c0-5.168-3.6-8.557-9.107-8.557-5.549 0-9.191 3.389-9.191 8.557v12.283c0 5.168 3.643 8.556 9.191 8.556m-4.15-20.713a4.129 4.129 0 018.258 0v12.03a4.129 4.129 0 01-8.258 0z"
            data-name="Path 5687"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M851.1 142.736l-.212-1.949h.379l6.948 19.019h5.93v-28.38h-5.041V148.5l.255 1.948h-.382l-6.988-19.018H846.1v28.38h5z"
            data-name="Path 5688"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M644.167 249.78c-13.342 0-22.1 8.147-22.1 20.571v29.534c0 12.424 8.759 20.572 22.1 20.572 13.239 0 21.9-8.148 21.9-20.572v-29.534c0-12.423-8.656-20.571-21.9-20.571m9.878 49.8c0 5.907-3.972 9.776-9.878 9.776-6.11 0-9.981-3.869-9.981-9.776v-28.923c0-5.906 3.871-9.777 9.981-9.777 5.906 0 9.878 3.871 9.878 9.777z"
            data-name="Path 5689"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M717.29 272.7c0-13.749-7.842-21.692-21.488-21.692h-21.081v68.232h12.018v-24.753h7.943l9.572 24.748h14.157l-12.12-26.783c7.13-3.158 11-9.879 11-19.757m-22.71 11.1h-7.842V262.1h7.842c6.721 0 10.591 3.971 10.591 10.8 0 6.925-3.87 10.9-10.591 10.9"
            data-name="Path 5690"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M0 0H12.018V68.233H0z"
            data-name="Rectangle 1458"
            transform="translate(13380.385 9305.003)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M859.056 249.78c-13.342 0-22.1 8.147-22.1 20.571v29.534c0 12.424 8.758 20.572 22.1 20.572 13.239 0 21.9-8.148 21.9-20.572v-29.534c0-12.423-8.657-20.571-21.9-20.571m9.878 49.8c0 5.907-3.972 9.776-9.878 9.776-6.11 0-9.979-3.869-9.979-9.776v-28.923c0-5.906 3.869-9.777 9.979-9.777 5.906 0 9.878 3.871 9.878 9.777z"
            data-name="Path 5691"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M920.874 251v41.042l.612 4.684h-.917L903.765 251H889.61v68.232h12.017v-41.039l-.508-4.683h.915l16.7 45.725h14.256V251z"
            data-name="Path 5692"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M577.969 262.1h14.46v57.134h12.02V262.1h9.841a5.2 5.2 0 004.518-4.437V251H577.97v11.1z"
            data-name="Path 5693"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M768.621 262.1h14.461v57.134H795.1V262.1h9.841a5.2 5.2 0 004.519-4.437V251h-40.838v11.1z"
            data-name="Path 5694"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M716.7 151.292V139.94c0-5.168-3.6-8.514-8.98-8.514h-8.641v28.38h8.641c5.379 0 8.98-3.346 8.98-8.514m-12.623 3.9v-19.149h3.473a3.805 3.805 0 014.151 4.066v11.014a3.805 3.805 0 01-4.151 4.066h-3.473z"
            data-name="Path 5695"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M797.348 151.292V139.94c0-5.168-3.6-8.514-8.979-8.514h-8.642v28.38h8.642c5.378 0 8.979-3.346 8.979-8.514m-12.623 3.9v-19.149h3.475a3.805 3.805 0 014.15 4.066v11.014a3.805 3.805 0 01-4.15 4.066h-3.475z"
            data-name="Path 5696"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M734.91 155.189h-9.656v-7.455h8.3v-4.49h-8.3v-7.2h7.491a2.165 2.165 0 002.165-2.165v-2.449h-14.654v28.38h14.654z"
            data-name="Path 5697"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M815.562 155.189H805.9v-7.455h8.3v-4.49h-8.3v-7.2h7.5a2.164 2.164 0 002.156-1.984v-2.63h-14.65v28.38h14.656z"
            data-name="Path 5698"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M746.771 160.315c5.379 0 8.938-3.3 8.938-8.345v-2.329h-2.928a2.162 2.162 0 00-2.07 2.16v.042a3.961 3.961 0 01-7.92 0V139.39a3.961 3.961 0 017.92 0v.036a2.165 2.165 0 002.164 2.165h2.834v-2.329c0-5.041-3.559-8.344-8.938-8.344-5.422 0-9.022 3.3-9.022 8.344v12.708c0 5.041 3.6 8.345 9.022 8.345"
            data-name="Path 5699"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M762.556 157.543l.778-3.921h7.074l1.177 6.184h5.6l-6.692-28.38h-7.03l-6.693 28.38h3.03a2.73 2.73 0 002.76-2.263m4.167-21.118h.3l2.5 12.707h-5.294z"
            data-name="Path 5700"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M737.149 251l-16.091 68.233h7.277c2.77-.135 5.934-1.517 6.636-5.441l1.873-9.427h17.007l1.88 9.467c.718 3.892 3.868 5.268 6.626 5.4h7.789L754.054 251h-16.9zm1.833 42.57l6.008-30.552h.714l6.007 30.552z"
            data-name="Path 5701"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M521.637 262.1a5.206 5.206 0 005.206-5.2V251h-35.237v68.232h35.237v-11.1h-23.219v-17.921h19.959v-10.8h-19.959V262.1z"
            data-name="Path 5702"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M574.35 300.12c0-24.646-28.922-18.129-28.922-31.979 0-4.684 3.157-7.434 7.943-7.434 4.689 0 7.85 2.52 8.213 6.457v-.057a3.283 3.283 0 003.116 3.274h8.633v-2.647c0-10.8-7.843-18.128-20.063-18.128-11.915 0-19.858 7.027-19.858 19.35 0 23.831 28.923 17.924 28.923 31.979 0 5.092-3.362 8.249-8.555 8.249-5.328 0-8.732-3.062-8.941-7.788v.073a3.288 3.288 0 00-3.211-3.284H532.9v2.75c0 11.711 8.352 19.349 20.979 19.349 12.322 0 20.469-7.333 20.469-20.164"
            data-name="Path 5703"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M453.516 294.487h7.942l9.575 24.748h14.155l-12.119-26.783c7.129-3.158 11-9.879 11-19.757 0-13.749-7.842-21.692-21.488-21.692H441.5v68.232h12.018zm0-32.383h7.842c6.721 0 10.591 3.971 10.591 10.8 0 6.926-3.87 10.9-10.591 10.9h-7.842z"
            data-name="Path 5704"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M555.358 169.947c-13.342 0-22.1 8.147-22.1 20.571v29.534c0 12.424 8.757 20.571 22.1 20.571 13.239 0 21.9-8.147 21.9-20.571v-29.534c0-12.424-8.656-20.571-21.9-20.571m9.878 49.8c0 5.906-3.972 9.776-9.878 9.776-6.11 0-9.979-3.87-9.979-9.776v-28.924c0-5.907 3.869-9.777 9.979-9.777 5.906 0 9.878 3.87 9.878 9.777z"
            data-name="Path 5705"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M663.826 171.16h-5.207l-.811 2.349-8.854 25.257h-.714l-8.216-23.192c.144.336.284.689.418 1.077l-1.9-5.491h-5.202c.191 0 .382 0 .57.008h-9.3l17.724 40.732v27.5h12.118v-27.5l17.618-40.736h-8.815c.189-.005.379-.008.571-.008"
            data-name="Path 5706"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M851.725 190.008h1.018l-.612 4.685V239.4h12.018v-68.232h-16.295l-10.59 36.967h-.714l-10.693-36.967h-16.7V239.4h12.017v-44.707l-.51-4.685h.916l10.592 34.727h8.962z"
            data-name="Path 5707"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M476.735 228.3h-23.219v-17.923h19.96v-10.795h-19.96v-17.313l18.013-.008a5.206 5.206 0 005.206-5.205v-5.887H441.5V239.4h35.236z"
            data-name="Path 5708"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M505.3 240.624c12.934 0 21.488-7.944 21.488-20.063v-5.6h-7.039a5.2 5.2 0 00-4.977 5.193v.1c0 5.7-3.871 9.267-9.472 9.267-5.806 0-9.573-3.564-9.573-9.267v-29.939c0-5.7 3.767-9.269 9.573-9.269 5.6 0 9.472 3.566 9.472 9.269v.086a5.205 5.205 0 005.205 5.206h6.811v-5.6c0-12.119-8.554-20.063-21.488-20.063-13.036 0-21.693 7.944-21.693 20.063v30.552c0 12.119 8.657 20.063 21.693 20.063"
            data-name="Path 5709"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M595.588 188.481c0-4.686 3.156-7.436 7.943-7.436 4.689 0 7.85 2.52 8.213 6.457v-.056a3.284 3.284 0 003.114 3.275h8.633v-2.648c0-10.795-7.842-18.128-20.062-18.128-11.916 0-19.858 7.028-19.858 19.35 0 23.83 28.922 17.924 28.922 31.978 0 5.092-3.362 8.249-8.554 8.249-5.328 0-8.732-3.062-8.942-7.788v.074a3.288 3.288 0 00-3.21-3.285h-8.726v2.75c0 11.711 8.351 19.35 20.979 19.35 12.322 0 20.47-7.333 20.47-20.165 0-24.645-28.922-18.127-28.922-31.977"
            data-name="Path 5710"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M694 240.624c12.323 0 20.471-7.333 20.471-20.165 0-24.645-28.923-18.128-28.923-31.977 0-4.686 3.157-7.436 7.944-7.436 4.689 0 7.849 2.52 8.212 6.457v-.056a3.284 3.284 0 003.116 3.275h8.633v-2.648c0-10.795-7.842-18.128-20.062-18.128-11.915 0-19.859 7.028-19.859 19.35 0 23.83 28.923 17.924 28.923 31.978 0 5.092-3.361 8.249-8.555 8.249-5.326 0-8.732-3.062-8.941-7.788v.074a3.289 3.289 0 00-3.211-3.285h-8.726v2.75c0 11.71 8.351 19.35 20.978 19.35"
            data-name="Path 5711"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M731.754 239.4h12.019v-57.132h9.842a5.2 5.2 0 004.517-4.436v-6.664H717.3v11.1h14.46V239.4z"
            data-name="Path 5712"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M795.211 182.214a5.2 5.2 0 005.184-4.771v-6.321h-35.236v68.232H800.4v-11.1h-23.22V210.33h19.96v-10.795h-19.96v-17.312z"
            data-name="Path 5713"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M450.291 160.274c5.28 0 8.744-3.21 8.744-8.11v-20.7h-4.985v20.572a3.783 3.783 0 01-7.561 0v-20.571H441.5v20.7c0 4.9 3.506 8.11 8.787 8.11"
            data-name="Path 5714"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M468.073 142.744l-.211-1.943h.38l6.927 18.967h5.914v-28.3h-5.026v17.023l.253 1.943h-.38l-6.97-18.966h-5.872v28.3h4.985z"
            data-name="Path 5715"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M0 0H4.985V28.302H0z"
            data-name="Rectangle 1485"
            transform="translate(13049.011 9185.466)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M498.866 159.768h4.985v-23.7h5.956v-4.6h-16.94v4.6h6z"
            data-name="Path 5716"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M527.294 155.164h-9.632v-7.435h8.279v-4.478h-8.279v-7.181h7.472a2.161 2.161 0 002.16-2.16v-2.444h-14.616v28.3h14.616v-4.6z"
            data-name="Path 5717"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M548.583 151.278v-11.322c0-5.153-3.592-8.49-8.955-8.49h-8.618v28.3h8.618c5.363 0 8.955-3.337 8.955-8.49m-12.589 3.886V136.07h3.464a3.8 3.8 0 014.141 4.055v10.983a3.8 3.8 0 01-4.141 4.056z"
            data-name="Path 5718"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M572.531 148.489l.254 1.943h-.38l-6.97-18.966h-5.872v28.3h4.986v-17.022l-.212-1.943h.38l6.928 18.968h5.914v-28.3h-5.028z"
            data-name="Path 5719"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M605.6 159.768h4.984v-23.7h5.956v-4.6H599.6v4.6h6z"
            data-name="Path 5720"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M637.116 160.274c5.491 0 9.082-3.379 9.082-8.532v-12.251c0-5.153-3.591-8.533-9.082-8.533-5.534 0-9.167 3.38-9.167 8.533v12.251c0 5.153 3.633 8.532 9.167 8.532m-4.139-20.656a4.119 4.119 0 018.237 0v12a4.119 4.119 0 01-8.237 0z"
            data-name="Path 5721"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M654.771 142.744l-.21-1.943h.38l6.927 18.967h5.914v-28.3h-5.026v17.023l.253 1.943h-.38l-6.97-18.966h-5.872v28.3h4.984z"
            data-name="Path 5722"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M585.9 157.523l.779-3.923h7.055l.778 3.923a2.788 2.788 0 002.735 2.245h3.245l-6.674-28.3h-7.014l-6.674 28.3h3.034a2.786 2.786 0 002.736-2.245m4.159-21.073h.3l2.491 12.672h-5.28z"
            data-name="Path 5723"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M679.481 160.258c5.1 0 8.481-3.038 8.481-8.354 0-10.211-11.983-7.511-11.983-13.249a2.963 2.963 0 013.292-3.08c1.942 0 3.251 1.044 3.4 2.675v-.023a1.36 1.36 0 001.291 1.356h3.577v-1.1c0-4.473-3.249-7.511-8.313-7.511-4.936 0-8.227 2.911-8.227 8.017 0 9.872 11.981 7.426 11.981 13.248a3.247 3.247 0 01-3.544 3.418c-2.207 0-3.617-1.269-3.705-3.227v.031a1.361 1.361 0 00-1.328-1.361h-3.613v1.139c0 4.852 3.461 8.017 8.691 8.017"
            data-name="Path 5724"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M456.141 349.389c2.294-3.222 3.709-6.492 3.709-9.713 0-5.32-3.66-8.688-9.126-8.688-5.564 0-9.225 3.367-9.225 8.395v2.685h3.368a2.391 2.391 0 002.391-2.392 3.189 3.189 0 013.416-3.367c2.05 0 3.369 1.269 3.369 3.611 0 1.9-.928 4.051-3.515 7.662l-8.98 12.495v4.2h18.2V359.1h-10.44v-.293z"
            data-name="Path 5725"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M472.613 330.988c-5.955 0-9.859 3.514-9.859 8.883v16.106c0 5.368 3.9 8.883 9.859 8.883 5.906 0 9.761-3.515 9.761-8.883v-16.106c0-5.369-3.855-8.883-9.761-8.883m4 24.843c0 2.245-1.61 3.709-4 3.709-2.441 0-4.052-1.415-4.052-3.709v-15.812c0-2.3 1.611-3.709 4.052-3.709 2.392 0 4 1.463 4 3.709z"
            data-name="Path 5726"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M499.988 349.389c2.294-3.222 3.709-6.492 3.709-9.713 0-5.32-3.66-8.688-9.126-8.688-5.565 0-9.225 3.367-9.225 8.395v2.685h3.368a2.391 2.391 0 002.391-2.392 3.189 3.189 0 013.416-3.367c2.05 0 3.369 1.269 3.369 3.611 0 1.9-.928 4.051-3.515 7.662l-8.98 12.495v4.2h18.2V359.1h-10.44v-.293z"
            data-name="Path 5727"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M506.23 334.941v5.466l4.638-2.683h.439v26.55h5.758v-32.7h-4.539z"
            data-name="Path 5728"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M548.125 349.389c2.295-3.222 3.709-6.492 3.709-9.713 0-5.32-3.659-8.688-9.126-8.688-5.563 0-9.225 3.367-9.225 8.395v2.685h3.368a2.391 2.391 0 002.391-2.392 3.19 3.19 0 013.417-3.367c2.05 0 3.368 1.269 3.368 3.611 0 1.9-.928 4.051-3.514 7.662l-8.981 12.495v4.2h18.2V359.1h-10.439v-.293z"
            data-name="Path 5729"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M564.6 330.988c-5.955 0-9.859 3.514-9.859 8.883v16.106c0 5.368 3.9 8.883 9.859 8.883 5.905 0 9.761-3.515 9.761-8.883v-16.106c0-5.369-3.856-8.883-9.761-8.883m4 24.843c0 2.245-1.611 3.709-4 3.709-2.441 0-4.052-1.415-4.052-3.709v-15.812c0-2.3 1.61-3.709 4.052-3.709 2.391 0 4 1.463 4 3.709z"
            data-name="Path 5730"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M591.787 347.582v-.341c2.489-1.025 4.2-4.051 4.2-7.663 0-5.125-3.71-8.59-9.176-8.59s-9.176 3.367-9.176 8.492v1.708h3.951a1.851 1.851 0 001.826-1.755v-.005a3.17 3.17 0 013.35-3.12c2 0 3.319 1.366 3.319 4.1 0 3.076-1.465 4.931-3.954 4.931h-3.709v4.686h4.245c2.441 0 3.905 1.854 3.905 4.929 0 3.025-1.562 4.588-3.855 4.588a3.578 3.578 0 01-3.759-3.9v-1.269h-5.759v1.659c0 5.271 3.808 8.834 9.566 8.834s9.615-3.66 9.615-9.078c0-3.954-1.8-7.176-4.587-8.2"
            data-name="Path 5731"
            transform="translate(12564 9054)"
          ></path>
          <path
            fill="#1d1d1b"
            d="M609.046 330.988c-5.955 0-9.859 3.514-9.859 8.883v16.106c0 5.368 3.9 8.883 9.859 8.883 5.906 0 9.761-3.515 9.761-8.883v-16.106c0-5.369-3.855-8.883-9.761-8.883m4 24.843c0 2.245-1.61 3.709-4 3.709-2.441 0-4.052-1.415-4.052-3.709v-15.812c0-2.3 1.61-3.709 4.052-3.709 2.392 0 4 1.463 4 3.709z"
            data-name="Path 5732"
            transform="translate(12564 9054)"
          ></path>
        </g>
        <path
          fill="#1d1d1b"
          d="M0 0H4.985V28.302H0z"
          data-name="Rectangle 1486"
          transform="translate(13183.011 9185.466)"
        ></path>
      </g>
    </svg>
  );
}

export default UNDecadeLogo;
